module.exports = __webpack_public_path__ + "img/jiujinjiuyi_image_zy.bcfc9948.png";